var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getJSONHeaders, handleJSONResponse } from 'utils/fetch';
import { addNotificationIcon } from './addNotificationIcon';
export function loadUserStats() {
    return __awaiter(this, void 0, void 0, function* () {
        const cartLinks = document.querySelectorAll('[data-cart-link]');
        if (cartLinks.length === 0) {
            return;
        }
        const res = yield fetch('/api/user/current_user/stats.json', {
            headers: getJSONHeaders(),
        });
        const { cartLineItems } = yield handleJSONResponse(res);
        if (cartLineItems > 0) {
            addNotificationIcon({
                items: cartLinks,
                label: 'Cart',
                count: cartLineItems,
            });
        }
    });
}
